import { gql } from "@apollo/client";

export const REVERTIR_ACTUALIZAR = gql`
mutation revertirActualizar($idPeriodo: Int!) {
    revertirActualizar(idPeriodo: $idPeriodo) {
        success
        valorEsperado
        error
    }
}`;